<div class="fondo">
    <legend>Cargando...</legend>
</div>